import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=71c79028"
import script from "./Liabilities.vue?vue&type=script&lang=js"
export * from "./Liabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports